import React from 'react';
import PropTypes from 'prop-types';
import VideoListItem from 'components/VideoListItem';
import { videoShape } from 'utils/shapes';
import './VideoList.css';

function VideoList({ videos, onVideoClick, nowPlayingVideo }) {
  return (
    <div className="video-list">
      <h3 className="title">Recent Uploads</h3>
      <ul>
        {videos.map(video => (
          <VideoListItem
            key={video.videoId}
            video={video}
            onVideoClick={onVideoClick}
            nowPlaying={
              nowPlayingVideo && nowPlayingVideo.videoId === video.videoId
            }
          />
        ))}
      </ul>
    </div>
  );
}

VideoList.propTypes = {
  videos: PropTypes.arrayOf(videoShape),
  onVideoClick: PropTypes.func,
  nowPlayingVideo: videoShape
};

export default VideoList;
